module.exports = __webpack_public_path__ + "static/img/2-1-2.1a130844.png";